(function($){

/* from gallery-section.js */
if ( $('.gallery-to-slick').length ){
	$('.gallery-to-slick').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		autoplay: false,
		draggable: true,
		arrows: false,
		swipeToSlide: true,
		touchThreshold: 10,
		infinite: true,
		//adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					autoplay: false,
					draggable: true,
					arrows: false,
					swipeToSlide: true,
					touchThreshold: 10,
					infinite: false,
					//adaptiveHeight: true,
				}
			}
		]
	});
}
/* from gallery-section.js */

})(jQuery);